import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from './styles.module.scss';
import leftArrowIcon from '../../Layout/icons/nav-arrow-left.svg';

export const NavHeader = ({ goBack, backString }) => (
  <div className={styles.container}>
    <button className={styles.backButton} onClick={goBack}>
      <img alt={'arrow'} src={leftArrowIcon} />
      <span className={styles.backLabel}>{backString}</span>
    </button>
  </div>
);

NavHeader.propTypes = {
  backString: PropTypes.string.isRequired,
  goBack: PropTypes.func.isRequired,
};

export default enhance(NavHeader);
